import React, { FC, useCallback, useEffect, useRef, useState } from "react";
import useMediaQuery from "@material-ui/core/useMediaQuery";

interface ICalculatorIframeProps {
  /** Extra className for the iframe element (optional). */
  className?: string;
}

const CalculatorIframe: FC<ICalculatorIframeProps> = ({ className }) => {
  const iframeRef = useRef<HTMLIFrameElement | null>(null);
  const isMobile = useMediaQuery("(max-width:760px)");
  const [frameHeight, setFrameHeight] = useState<number>(isMobile ? 1400 : 1900);

  const syncFrameHeight = useCallback(() => {
    const iframe = iframeRef.current;
    if (!iframe || !iframe.contentDocument) return;

    const doc = iframe.contentDocument;
    const body = doc.body;
    const html = doc.documentElement;
    if (!body || !html) return;

    const contentHeight = Math.max(
      body.scrollHeight,
      body.offsetHeight,
      html.clientHeight,
      html.scrollHeight,
      html.offsetHeight
    );

    if (contentHeight > 0) {
      setFrameHeight(contentHeight);
    }
  }, []);

  useEffect(() => {
    setFrameHeight(isMobile ? 1400 : 1900);
  }, [isMobile]);

  useEffect(() => {
    const handleResize = () => syncFrameHeight();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [syncFrameHeight]);

  return (
    <iframe
      ref={iframeRef}
      className={className}
      title="StarFarm Earnings Calculator"
      src="/earnings-calculator.html"
      onLoad={syncFrameHeight}
      style={{
        width: "100%",
        height: `${frameHeight}px`,
        border: "none",
        display: "block",
        backgroundColor: "#0b0d20",
      }}
    />
  );
};

export default CalculatorIframe;
